import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="w-full bg-dark py-12 px-4 border-t border-darkBorder" data-id="element-121">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center gap-6" data-id="element-122">
        <p className="font-playfair text-cream/50 text-sm" data-id="element-123">
          © {currentYear} Resin Without Errors™. All Rights Reserved.
        </p>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-lato text-xs text-cream/40" data-id="element-124">
          <a href="#" className="hover:text-amber transition-colors" data-id="element-125">
            Contact Support
          </a>
          <span className="hidden md:inline" data-id="element-126">|</span>
          <a href="#" className="hover:text-amber transition-colors" data-id="element-127">
            Privacy Policy
          </a>
          <span className="hidden md:inline" data-id="element-128">|</span>
          <a href="#" className="hover:text-amber transition-colors" data-id="element-129">
            Terms of Use
          </a>
          <span className="hidden md:inline" data-id="element-130">|</span>
          <a href="#" className="hover:text-amber transition-colors" data-id="element-131">
            Refund Policy
          </a>
        </div>

        <p className="font-lato text-[10px] text-cream/30 max-w-2xl mt-4 leading-relaxed" data-id="element-132">
          Disclaimer: Results may vary. Individual experiences are not
          guaranteed. This is a digital product.
        </p>
      </div>
    </footer>;
}